import React from "react";
import styles from "./Coupon.module.css";
import { format } from "date-fns";

const formatDate = (date) => {
  if (!date) return "--";
  try {
    return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
  } catch {
    return date;
  }
};

const formatText = (text) => {
  if (typeof text !== "string") return text;
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

function DetailsTable({ canvasData }) {
  if (!canvasData) return null;

  return (
    <table className={styles.details}>
      <tbody>
        <tr>
          <td>Coupon Title:</td>
          <td className={styles.textMuted}>{canvasData.title || "--"}</td>
        </tr>

        <tr>
          <td>Coupon Code:</td>
          <td className={styles.textMuted}>{canvasData.code || "--"}</td>
        </tr>

        <tr>
          <td>Discount Type:</td>
          <td className={styles.textMuted}>
            {formatText(canvasData.discountType) || "--"}
          </td>
        </tr>

        <tr>
          <td>Discount Value:</td>
          <td className={styles.textMuted}>{canvasData.discountValue ?? "--"}</td>
        </tr>

        <tr>
          <td>Start Date:</td>
          <td className={styles.textMuted}>{formatDate(canvasData.startDt)}</td>
        </tr>

        <tr>
          <td>Expiry Date:</td>
          <td className={styles.textMuted}>{formatDate(canvasData.expiryDt)}</td>
        </tr>

        <tr>
          <td>Usage Limit:</td>
          <td className={styles.textMuted}>{canvasData.usageLimit ?? "--"}</td>
        </tr>

        <tr>
          <td>Usage Count:</td>
          <td className={styles.textMuted}>{canvasData.usageCount ?? "--"}</td>
        </tr>

        <tr>
          <td>Status:</td>
          <td className={styles.textMuted}>{canvasData.status || "--"}</td>
        </tr>

        <tr>
          <td>Partner Code:</td>
          <td className={styles.textMuted}>{canvasData.partnerCode || "--"}</td>
        </tr>

        <tr>
          <td>Plan Code:</td>
          <td className={styles.textMuted}>{canvasData.planCode || "--"}</td>
        </tr>

        <tr>
          <td>Created At:</td>
          <td className={styles.textMuted}>
            {formatDate(canvasData.createdAt)}
          </td>
        </tr>

        <tr>
          <td>Created By:</td>
          <td className={styles.textMuted}>{canvasData.createdBy || "--"}</td>
        </tr>

        <tr>
          <td>Updated At:</td>
          <td className={styles.textMuted}>
            {formatDate(canvasData.updatedAt)}
          </td>
        </tr>

        <tr>
          <td>Updated By:</td>
          <td className={styles.textMuted}>{canvasData.updatedBy || "--"}</td>
        </tr>

        <tr>
          <td>Comment:</td>
          <td className={styles.textMuted}>{canvasData.comment || "--"}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default DetailsTable;
